


export function clearLocalStorage() {
  let mem = [
    'businessPayment',
    'regInfo',
    'paymentInfo',
    'queryInfo',
    'responseurl',
    'affiliates',
    'natureOfBusiness',
    'meetings',
    'constitution',
    'sourceOfIncomes',
    'secretary',
    'objectives',
    'documents',
    'receipt',
    'articles',
    'shareholders',
    'deponent',
    'abcxyz',
    'consentCode',
    'ctc_qrcode',
    "consentCodeCompanyDetails",
    "stampDuty",
    "stampDutyPayload",
    "publication",
    "consitution",
    "witnesses",
    "psc"
  ];
  mem.forEach(m =>{
    localStorage.removeItem(m);
    sessionStorage.removeItem(m);
  });
}
